export const COEFFICIENTS = {
    "BLOWS": 0.875888, //Удары
    "BLOWS_2": 0.840655, //Удары в створ
    "GOALS": 0.906427, //Голы
    "PERCENTS_ACCURATE_PASS": 0.770022, //% точных передач
    "PERCENTS_NO_ACCURATE_PASS": -0.770022,//% неточных передач
    "EFFECTIVE_STROKES": 0.632292, //Эффективные обводки
    "GOALS_PASS": 0.850134, //Голевые передачи
    "SELECTIONS": 0.253829,//Отборы
    "LOSSES": -0.891862,//Потери
    "SAVES": 0.902234,//Отбитые мячи (для вратарей)
    "MISSED_BALLS": -0.950324 //Пропущенные мячи (для вратарей)
}